<div class="bs-dialog bs-dialog-wide">
    <form novalidate [formGroup]="emailForm" (ngSubmit)="change(emailForm.value)" method="post">
        <div class="bs-dialog-title">
            <span i18n>Change email</span>
            <a class="bs-dialog-close" (click)="close()"><i class="fa fa-close"></i></a>
        </div>
        <div class="bs-dialog-progress">
            @if (isBusy) {
            <bs-progress-bar class="thin" [indeterminate]="true"></bs-progress-bar>
            }
        </div>
        <div class="bs-dialog-content bs-dialog-content-xpadded">
            <div class="flexbox-row flexbox-align-center-center">
                <div class="flex-40">
                    <bs-input>
                        <input
                            type="text"
                            name="email"
                            [formControl]="emailForm.controls['email'] | formControl"
                            [disabled]="isBusy"
                            autofocus
                        />
                        <label i18n>New email</label>
                        <div class="input-errors">
                            @if (emailForm.controls['email'].hasError('required')) {
                            <span i18n>Email is required</span>
                            } @if (emailForm.controls['email'].hasError('unique')) {
                            <span i18n>This email address is already taken</span>
                            } @if (emailForm.controls['email'].hasError('pattern')) {
                            <span i18n>Please, specify valid email address</span>
                            }
                        </div>
                    </bs-input>

                    <bs-input>
                        <input
                            type="password"
                            name="password"
                            [formControl]="emailForm.controls['password'] | formControl"
                            [disabled]="isBusy"
                        />
                        <i
                            class="fa fa-eye"
                            bsViewPassword
                            title="Toggle password visibility"
                            i18n-title
                        ></i>
                        <label i18n>Password</label>
                        <div class="input-errors">
                            @if (emailForm.controls['password'].hasError('required')) {
                            <span i18n>Password is required</span>
                            }
                        </div>
                    </bs-input>
                </div>
            </div>

            @if (initiator!=='activate') {
            <div class="padding-top-large text-center" i18n>
                A confirmation request is going to be sent to the new email address. The actual
                change is going to happen only once the new email is confirmed.
            </div>
            } @if (initiator==='activate') {
            <div class="padding-top-large text-center" i18n>
                Current address has not yet been verified, the change will happen immediately. New
                activation email will be resent to the new address.
            </div>
            }

            <input
                type="submit"
                class="bs-fake-submit"
                value="Login"
                [disabled]="!emailForm.valid"
                tabindex="-1"
            />
        </div>
        <div class="bs-dialog-actions">
            <button class="bs-button" type="button" (click)="close()" [disabled]="isBusy" i18n>
                Cancel
            </button>
            <button
                class="bs-button bs-primary"
                type="submit"
                [disabled]="!emailForm.valid || isBusy"
                i18n
            >
                Proceed
            </button>
        </div>
    </form>
</div>
